module.exports = __webpack_public_path__ + "media/images/flags/LGBT-eebcb251087af0d330d73b4736007a41.svg";